
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";
import {
  QuestionV2Object,
  QuestionV2,
  EnumQuestionType
} from "@/lib/model/exambuilder/question-v2";

import QuestionCardV2 from "@/views/ai-builder-component/question-card-v2/question-card-v2.vue";
import QuestionEdit from "@/views/ai-builder-component/components/question-edit.vue";
import Dimensions, {
  Dimension,
  DimensionRes
} from "../../lib/dimension/dimension";
import request from "@/lib/request/request";
import DimensionEdit from "./components/dimension-edit.vue";
import QuestionImport from "./components/question-import.vue";
import PositionList, { PositionIndustryList } from "@/lib/position/position";
import MsgRequest from "@/lib/model/message/MsgRequest";
import AsyncDownloadModal from "@/views/exam-component/components/async-download-modal.vue";

@Component({
  components: {
    QuestionCardV2,
    QuestionEdit,
    DimensionEdit,
    AsyncDownloadModal,
    QuestionImport
  }
})
export default class QuestionStore extends Vue {
  pathText = "题库";
  questionList: QuestionV2[] = [];
  dimensionList: Dimension[] = []; //所有维度
  dimensionListDiy: Dimension[] = []; //自定义维度
  isExpandDimensionFromSystem = false; // 默认收起历史公有维度保留
  dimensionListFromSystem: Dimension[] = []; // 历史公有维度保留 若为空则不展示
  dimensionListDef: Dimension[] = []; //标准维度\
  noDimensionQuestionCount = 0;
  showDimensionEdit = false;
  selectedDimension: Dimension | null = null;
  isSelectNoDimension = false;
  positionMap = new PositionIndustryList();
  positionId = 0;
  industryId = 0;
  hasQuestionOwnerStatusPrivate2 = false; // 是否存在从旧公有题库转义来的私有题目

  //弹窗model
  currentQuestion: QuestionV2 | null = null;
  showDel = false;
  showQuestionEdit = false;

  // 分页
  currentPage = 1;
  totalCount = 0;
  pageSize = 10;

  height = "";

  dimensionCount = 0;
  dimensionCountDef = 0;

  activeName = "default";

  //筛选
  isAppendAsk = 0;
  filterQuestionType = 0;
  filterScoreRuleStatus = 0;
  filterOwnerStatus = 0;
  filterIndustry = -1;
  filterPost = -1;
  searchType = 0;
  searchKeyword = "";
  searchTypeOptions = [
    {
      value: 0,
      label: "题干关键字"
    },
    {
      value: 1,
      label: "备注关键字"
    }
  ];
  industryList: any[] = [{ label: "全部", value: -1 }];
  postList: any[] = [{ label: "不限", value: -1 }];
  searchTimer = 0;

  // 数据加载完成前不展示空页面
  dataLoaded = false;
  // 结果是否经过筛选和搜索，如果是就显示另一个无结果的样式
  isListFiltered = false;

  created() {
    //
  }
  //内部使用
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }
  get isStartFilter() {
    return (
      true &&
      this.filterQuestionType === 0 &&
      this.filterScoreRuleStatus === 0 &&
      this.filterOwnerStatus === 0 &&
      this.filterIndustry === -1 &&
      this.filterPost === -1 &&
      this.searchKeyword === ""
    );
  }

  async mounted() {
    if (this.setWeb) {
      this.searchTypeOptions.push({ value: 2, label: "题目ID" });
    }
    await this.filterChanged();
    await this.getCompany();
    await this.getDimensionList();
    await this.getQuestionList();

    await this.getFilterList();
    this.$nextTick(() => this.getHeight());
    window.addEventListener("resize", this.getHeight);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.getHeight);
  }

  async getCompany() {
    const res = await MsgRequest.getCompanyInfo(parseInt(Auth.companyId));
    this.hasQuestionOwnerStatusPrivate2 =
      res.data.hasQuestionOwnerStatusPrivate2;
  }

  async getFilterList() {
    const {
      data: { data }
    } = await request.post("/aiExam/question2/features", {
      companyId: Number(Auth.companyId)
    });
    this.industryList = [
      { label: "全部", value: -1 },
      ...(data as any).questionIndustryList.map((el: any) => ({
        label: el.name,
        value: el.questionIndustryId
      }))
    ];
    this.postList = [
      { label: "不限", value: -1 },
      ...(data as any).questionPositionList.map((el: any) => ({
        label: el.name,
        value: el.questionPositionId
      }))
    ];
  }

  getHeight() {
    const mainHeight = (this.$refs.main as any).offsetHeight;
    const filterHeight = (this.$refs.filterCtx as any).offsetHeight;
    const height = mainHeight - filterHeight - 10 - 28 - 24 - 16; // 容器 - 过滤器高 - 过滤器margin - 容器padding - 分页 - 分页margin-top
    this.height = height + "px";
  }

  tabClick(e: any) {
    this.activeName = e.name;
    this.selectedDimension = null;
    // this.getDimensionList();
    this.filterChanged();
  }

  getLabel(value: number) {
    const obj = {
      0: "全部",
      10: "标准题库",
      20: "私有题库",
      22: "历史公有题库保留"
    };
    return obj[value];
  }

  onLoadedDimensionList(list: any) {
    this.dimensionList = list;
    //自定义维度
    this.dimensionListDiy = this.dimensionList.filter(
      (d: Dimension) =>
        d.isSystemDimension !== 1 && d.isFromSystemDimension !== 1
    );
    //标准维度
    this.dimensionListDef = this.dimensionList.filter(
      (d: Dimension) =>
        d.isSystemDimension === 1 && d.isFromSystemDimension !== 1
    );
    // 历史公有维度保留
    this.dimensionListFromSystem = this.dimensionList.filter(
      (d: Dimension) => d.isFromSystemDimension === 1
    );
  }

  async onCloseDimensionEdit() {
    this.showDimensionEdit = false;
    await this.getDimensionList();

    // 要检查一下当前维度是否已经被删除了
    if (this.selectedDimension != null) {
      let needResetDimension = true;
      for (const dim of this.dimensionList) {
        if (this.selectedDimension.dimensionKey == dim.dimensionKey) {
          needResetDimension = false;
          break;
        }
      }
      if (needResetDimension) this.selectedDimension = null;
    }
    this.getQuestionList();
  }
  clearFilter() {
    this.filterQuestionType = 0;
    this.filterScoreRuleStatus = 0;
    this.filterOwnerStatus = 0;
    this.isAppendAsk = 0;
    this.filterIndustry = -1;
    this.filterPost = -1;
    this.searchKeyword = "";
    this.filterChanged();
  }
  setFilterQuestionType(type: number) {
    if (
      this.filterScoreRuleStatus != 0 &&
      type == EnumQuestionType.EnumQuestionTypeNewSingleChoice
    ) {
      // 筛选了状态就不能选选择题了
      return;
    }

    this.filterQuestionType = type;
    if (
      this.filterQuestionType ==
      EnumQuestionType.EnumQuestionTypeNewSingleChoice
    ) {
      this.filterScoreRuleStatus = 0;
    }
    this.filterChanged();
  }
  setScoreRuleStatus(type: number) {
    if (
      this.filterQuestionType ==
        EnumQuestionType.EnumQuestionTypeNewSingleChoice &&
      type != 0
    ) {
      // 选择题不能筛选状态
      return;
    }
    this.filterScoreRuleStatus = type;
    // if (this.filterScoreRuleStatus == EnumQuestionType.EnumQuestionTypeNewSingleChoice) {
    //   this.filterQuestionType = EnumQuestionType.EnumQuestionTypeVideo;
    // }

    this.filterChanged();
  }
  // 追问
  setInquiryStatus(type: number) {
    this.isAppendAsk = type;
    this.filterChanged();
  }

  setOwnerFilterStatus(type: number) {
    this.filterOwnerStatus = type;
    this.filterChanged();
  }

  setFilterIndustry(type: number) {
    this.filterIndustry = type;
    this.filterChanged();
  }

  setFilterPost(type: number) {
    this.filterPost = type;
    this.filterChanged();
  }

  search() {
    if (this.searchTimer) clearTimeout(this.searchTimer);

    this.searchTimer = setTimeout(() => {
      this.filterChanged();
      this.searchTimer = 0;
    }, 100);
  }

  async filterChanged(resetPage = true) {
    resetPage && (this.currentPage = 1);
    this.currentPage = 1;
    this.getDimensionList();
    this.getQuestionList();
  }

  getFilterRuleStatusClass(status: number) {
    if (
      this.filterQuestionType ==
        EnumQuestionType.EnumQuestionTypeNewSingleChoice &&
      status != 0
    ) {
      return "filter-btn-disable";
    } else
      return this.filterScoreRuleStatus === status
        ? "filter-btn-highlight"
        : "";
  }

  getFilterOwnerStatusClass(status: number) {
    return this.filterOwnerStatus === status ? "filter-btn-highlight" : "";
  }

  // 获取维度列表
  async getDimensionList() {
    const param: any = {
      companyId: Number(Auth.companyId)
    };
    if (this.isAppendAsk != 0) param["isAppendAsk"] = this.isAppendAsk;
    if (this.filterQuestionType != 0)
      param["questionType"] = this.filterQuestionType;

    if (this.filterScoreRuleStatus != 0)
      param["scoreRuleStatus"] = this.filterScoreRuleStatus;

    if (this.filterOwnerStatus != 0)
      param["ownerStatus"] = this.filterOwnerStatus;

    if (this.searchKeyword != "") {
      if (this.searchType == 0) param["descLike"] = this.searchKeyword;
      else if (this.searchType == 1) param["remarkLike"] = this.searchKeyword;
    }
    if (this.filterIndustry != -1) {
      param["questionIndustryIdList"] = [this.filterIndustry];
    }
    if (this.filterPost != -1) {
      param["questionPositionIdList"] = [this.filterPost];
    }

    param["isSystemDimension"] = this.activeName === "default" ? 1 : 2;

    Dimensions.get(param).then((res: DimensionRes) => {
      this.noDimensionQuestionCount = res.noDimensionQuestionCount;
      if (this.activeName === "default") {
        this.dimensionCountDef = res.allQuestionCount;
      } else {
        this.dimensionCount = res.allQuestionCount;
      }
      this.onLoadedDimensionList(res.list);
    });
  }

  // 获取题目列表
  selectedQuestionIds: number[] = [];

  async getQuestionList() {
    this.dataLoaded = false;
    this.isListFiltered =
      this.filterQuestionType != 0 ||
      this.filterScoreRuleStatus != 0 ||
      this.filterOwnerStatus != 0 ||
      this.isAppendAsk != 0 ||
      this.searchKeyword != "";
    const param: any = {
      page: this.currentPage,
      pageSize: this.pageSize
    };
    if (this.selectedDimension) {
      param["dimensionKey"] = this.selectedDimension.dimensionKey;
    } else if (this.isSelectNoDimension) {
      param["noDimension"] = 1;
    } else {
      param["isSystemDimension"] = this.activeName === "default" ? 1 : 2;
    }
    if (this.isAppendAsk != 0) param["isAppendAsk"] = this.isAppendAsk;

    if (this.filterQuestionType != 0)
      param["questionType"] = this.filterQuestionType;

    if (this.filterScoreRuleStatus != 0)
      param["scoreRuleStatus"] = this.filterScoreRuleStatus;
    if (this.filterOwnerStatus != 0)
      param["ownerStatus"] = this.filterOwnerStatus;

    if (this.searchKeyword != "") {
      if (this.searchType == 0) param["descLike"] = this.searchKeyword;
      else if (this.searchType == 1) param["remarkLike"] = this.searchKeyword;
      else if (this.searchType == 2) param["questionId"] = this.searchKeyword;
    }

    if (this.filterIndustry != -1) {
      param["questionIndustryIdList"] = [this.filterIndustry];
    }
    if (this.filterPost != -1) {
      param["questionPositionIdList"] = [this.filterPost];
    }
    const qo2 = await QuestionV2Object.get(param);
    this.totalCount = qo2.count;

    if (this.$refs.questionContent) {
      (this.$refs.questionContent as HTMLElement).scrollTop = 0;
    }
    this.questionList = qo2.list;
    this.questionList.forEach(q => {
      q.selected = this.selectedQuestionIds.some(id => id == q.questionId);
    });
    this.dataLoaded = true;
  }

  // 选中题目
  selectQuestion(questionId: number) {
    const hasSelected = this.selectedQuestionIds.some(id => id == questionId);
    const question = this.questionList.find(q => q.questionId == questionId);

    if (question) {
      question.selected = !hasSelected;
    }

    if (hasSelected) {
      this.selectedQuestionIds = this.selectedQuestionIds.filter(
        id => id != questionId
      );
    } else {
      this.selectedQuestionIds.push(questionId);
    }
  }

  handleClearSelected() {
    this.selectedQuestionIds = [];
    this.questionList.forEach(q => {
      q.selected = false;
    });
  }

  // 导出题目
  isShowDownloadModal = false;

  exportQuestion() {
    QuestionV2Object.exportByIds({
      questionIdList: this.selectedQuestionIds
    }).then(res => {
      if (res.code === 0) {
        this.isShowDownloadModal = true;
      }
    });
  }

  isShowImportModal = false;

  async addQuestion(scenes: string, e?: any) {
    if (e?.disabled) return;

    if (scenes === "add") {
      this.createQuestion();
      return;
    }

    if (scenes === "import") {
      this.isShowImportModal = true;
      return;
    }
  }

  // 选择维度
  selectDimension(dim: Dimension | null) {
    this.isSelectNoDimension = false;

    this.selectedDimension =
      this.selectedDimension === dim || !dim ? null : dim;

    this.currentPage = 1;
    this.getQuestionList();
  }

  // 筛选没有维度的题目
  selectOther() {
    this.selectedDimension = null;
    this.isSelectNoDimension = !this.isSelectNoDimension;
    this.currentPage = 1;
    this.getQuestionList();
  }

  getDimensionClass(dim: Dimension) {
    if (this.selectedDimension?.dimensionKey === dim.dimensionKey) {
      return "dimension-item-highlight";
    }

    return "";
  }

  onEditQuestion(question: any) {
    this.currentQuestion = question;
    this.showQuestionEdit = true;
  }

  onDeleteQuestion(question: any) {
    this.currentQuestion = question;
    this.showDel = true;
  }

  createQuestion() {
    this.currentQuestion = null;
    this.showQuestionEdit = true;
  }

  onCloseEditQuestion(hasChanged: boolean) {
    this.currentQuestion = null;
    this.showQuestionEdit = false;

    if (hasChanged) this.filterChanged(false);
  }

  async confirmDelete() {
    this.showDel = false;
    try {
      if (this.currentQuestion) {
        const questionId = this.currentQuestion.questionId;
        await QuestionV2Object.delete(questionId);
        this.$message.success("删除成功");
        this.filterChanged(false);
      }
    } catch (e) {
      this.$message.error("删除失败，请重试");
    }
  }

  handleSizeChange(size: number) {
    this.pageSize = size;
    this.getQuestionList();
  }

  handleCurrentChange(currentPage: number) {
    this.currentPage = currentPage;
    this.getQuestionList();
  }

  @Emit()
  change() {
    return;
  }
}
